import { render, staticRenderFns } from "./tabListLayout.vue?vue&type=template&id=2558d527&scoped=true&"
import script from "./tabListLayout.vue?vue&type=script&lang=js&"
export * from "./tabListLayout.vue?vue&type=script&lang=js&"
import style0 from "./tabListLayout.vue?vue&type=style&index=0&id=2558d527&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2558d527",
  null
  
)

export default component.exports